"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var core_1 = __importStar(require("@gin-betting/core"));
var convertBetStatus = core_1.default.utils.convertBetStatus;
function handleUpdateBet(state, action) {
    var bets = action.payload.entities.bets;
    var betFromEntities = lodash_1.values(bets)[0];
    if (!betFromEntities)
        return state;
    var status = betFromEntities.status, betIdFromEntities = betFromEntities.id;
    var betslipOdds = state.betslipOdds;
    var nextBetslipOdds = betslipOdds.map(function (currBetslipOdd) {
        var betId = currBetslipOdd.betId, fixedCoef = currBetslipOdd.fixedCoef;
        if (betId !== betIdFromEntities)
            return currBetslipOdd;
        var nextStatus = convertBetStatus(status);
        var isError = nextStatus === core_1.App.BetslipStatus.ERROR;
        var nextFixedCoef = isError ? null : fixedCoef;
        return __assign(__assign({}, currBetslipOdd), { singleStatus: nextStatus, fixedCoef: nextFixedCoef });
    });
    return state.set('betslipOdds', nextBetslipOdds);
}
exports.default = handleUpdateBet;
//# sourceMappingURL=handleUpdateBet.js.map